import React from 'react';
import './InfoBlock.css';
import Grid from '@material-ui/core/Grid';
import {Typography} from "@material-ui/core";

const InfoBlock = (props) => {
    const getGradientClass = () => {
        switch(props.text) {
            case 'Αναμονή': return 'gradient-waiting';
            case 'Σήμερα': return 'gradient-today';
            case 'Χθες': return 'gradient-yesterday';
            case 'Σύνολο': return 'gradient-total';
            default: return '';
        }
    };

    return(
      <div className={['infoBlockAgent', props.coloredNumber ? 'colored': null, getGradientClass(), props.onClick ? 'clickable' : null ].join(' ')} onClick={props.onClick}>

          <Grid
              container spacing={0}
              direction="column"
              justify="center"
              alignItems="center"
          >

              <Grid item className='number'>
                  <Typography variant={props.styleNumber}>
                      {props.number}
                  </Typography>
              </Grid>

              <Grid item className='text'>
                  <Typography variant='body2' component='div'>
                      {props.text}
                  </Typography>
              </Grid>


          </Grid>

      </div>
    );
};

export default  InfoBlock;